import { render, staticRenderFns } from "./EditAppAffiliateTemplate.vue?vue&type=template&id=71f25470"
import script from "./EditAppAffiliateTemplate.vue?vue&type=script&lang=ts"
export * from "./EditAppAffiliateTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports